var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { AssetsList } from "../store/types";
import { useFetchAssetsPrice } from "./useAssetPrice";
export var defaultAssetsPriceData = Object.fromEntries(AssetsList.map(function (asset) { return [
    asset,
    {
        loading: true,
        latestPrice: 0,
        dailyChange: 0,
    },
]; }));
export var defaultAssetsHistoricalPriceData = Object.fromEntries(AssetsList.map(function (asset) { return [
    asset,
    {
        loading: true,
        history: {},
    },
]; }));
export var defaultExternalAPIData = {
    assetsPrice: { data: defaultAssetsPriceData },
    assetsHistoricalPrice: { data: defaultAssetsHistoricalPriceData },
};
export var ExternalAPIDataContext = React.createContext(defaultExternalAPIData);
export var ExternalAPIDataContextProvider = function (_a) {
    var children = _a.children;
    var _b = useFetchAssetsPrice(), assetsPrice = _b.assetsPrice, assetsHistoricalPrice = _b.assetsHistoricalPrice;
    return (_jsx(ExternalAPIDataContext.Provider, __assign({ value: {
            assetsPrice: assetsPrice,
            assetsHistoricalPrice: assetsHistoricalPrice,
        } }, { children: children }), void 0));
};
//# sourceMappingURL=externalAPIDataContext.js.map